// extracted by mini-css-extract-plugin
var _1 = "_hIvRG";
var _2 = "_crVcv";
export { _1 as "loadingRowRect", _2 as "loadingRowSpinner" }
